import { render, staticRenderFns } from "./RollerBrakeTesterMC.vue?vue&type=template&id=58b785d3&scoped=true&"
import script from "./RollerBrakeTesterMC.vue?vue&type=script&lang=js&"
export * from "./RollerBrakeTesterMC.vue?vue&type=script&lang=js&"
import style0 from "./RollerBrakeTesterMC.vue?vue&type=style&index=0&id=58b785d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b785d3",
  null
  
)

export default component.exports